import { ImageConfigEntry } from '../../core/base-api';
import { ActivatedRoute, Router } from '@angular/router';
import { FormatConfigService } from '../../core/services/format-config.service';
import { TranslateService } from '@ngx-translate/core';
import { AppImageConfig } from '../../core/services/app-image-config';
import { Subscription } from 'rxjs';
import { Directive, OnDestroy } from '@angular/core';
import SizeTypeEnum = ImageConfigEntry.SizeTypeEnum;

@Directive()
export abstract class ConfigurableImageComponent implements OnDestroy {
  protected imageElementToImagePathMapping: Map<ImageConfigEntry.ElementEnum, string>;

  private imageConfig: AppImageConfig;

  protected imagePath: string = null;
  imageSize: SizeTypeEnum = SizeTypeEnum.DEFAULT;

  private subscription: Subscription = new Subscription();

  abstract registerImagePaths();

  protected constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected type: ImageConfigEntry.TypeEnum,
    private formatService: FormatConfigService,
    private translateService: TranslateService
  ) {
    this.imageElementToImagePathMapping = new Map();
    this.type = type;
    this.registerImagePaths();
    this.subscription.add(
      this.formatService.imageConfig$.subscribe((config) => {
        this.imageConfig = config;
        this.reset();
      })
    );
    this.subscription.add(this.translateService.onLangChange.subscribe((l) => this.reset()));
  }

  private reset() {
    if (!this.imageConfig) {
      return;
    }
    const configuredImageElement = this.imageConfig.getImageFormatForCurrentLanguage(this.type);
    if (configuredImageElement) {
      if (configuredImageElement.element) {
        this.imagePath = this.imageElementToImagePathMapping.get(configuredImageElement.element);
      }
      if (configuredImageElement.sizeType) {
        this.imageSize = configuredImageElement.sizeType;
      }
    }
  }

  protected bindImages(image: ImageConfigEntry.ElementEnum, imagePath: string) {
    this.imageElementToImagePathMapping.set(image, imagePath);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
